export default __webpack_public_path__ + "d6ea2cdef962bc242ae2ba093045e270.png";